var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandingLogoRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 18,
    cy: 19,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.37C.071 7.725 7.936-.044 17.582 0 27.23.046 35.02 7.89 35 17.536 34.98 27.182 27.158 34.994 17.511 35A17.565 17.565 0 0 1 .001 17.37m17.64 11.148A10.802 10.802 0 1 0 6.914 17.716c-.018 5.944 4.783 10.779 10.727 10.802",
    fill: "#EC004A",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingLogoRed);
export default __webpack_public_path__ + "static/media/BRANDING_LOGO_red.svg";
export { ForwardRef as ReactComponent };